<template>
  <div class="page" v-loading="loading">
    <div class="flex-wrap flex-sa">
      <div class="tab-box">
        <span class="tab-item" v-for="(tab, index) in tabList" :key="index"
          :class="{ activeTab: searchData.Status == tab.id }" @click="handOrderStatus(tab)">{{ tab.label }}
          <span class="tag">{{ tab.num }}</span>
        </span>
      </div>
      <toolbar style="margin-left: 10px" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
    </div>
    <div class="bd-b"></div>
    <el-form class="form-bg" :model="searchData" label-width="90px" ref="searchData">
      <el-row>
        <el-col :span="6">
          <el-form-item label="子订单号" prop="OrderNo">
            <el-input v-model="searchData.OrderNo" placeholder="子订单号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品名称" prop="ProductSkuName">
            <el-input v-model="searchData.ProductSkuName" placeholder="商品名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="型号" prop="ProductModel">
            <el-input v-model="searchData.ProductModel" placeholder="型号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收货人姓名" prop="ReceivingName">
            <el-input v-model="searchData.ReceivingName" placeholder="收货人姓名"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="收货人电话" prop="ReceivingMobile">
            <el-input v-model="searchData.ReceivingMobile" placeholder="收货人电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="选择供应商" prop="SupplierId">
            <el-select v-model="searchData.SupplierId" filterable remote placeholder="选择供应商"
              :remote-method="querySupplier" style="width: 100%">
              <el-option v-for="item in supplier" :key="item.id" :label="item.proSupplierName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="外部订单号" prop="OutOrderNo">
            <el-input v-model="searchData.OutOrderNo" placeholder="外部订单号"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="" prop="RemotePaymentStatus">
            <el-select
              v-model="searchData.RemotePaymentStatus"
              placeholder="付款状态"
              style="width: 100%"
            >
              <el-option label="待付款" :value="0"></el-option>
              <el-option label="部分付款" :value="1"></el-option>
              <el-option label="已付款" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>  -->
        <el-col :span="6">
          <el-form-item label="下单日期">
            <el-date-picker v-model="datePicker" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              range-separator="至" start-placeholder="下单开始日期" end-placeholder="下单结束日期" @change="handlePicker" class="w100">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item>
            <div class="flex">
              <el-button type="primary" @click="getData">查询</el-button>
              <el-button @click="resetForm">重置</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="flex-wrap flex-col h100 overflow-y">
      <div class="flex-1">
        <el-table border :data="tableData" style="width: 100%" :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }" :row-class-name="tableRowClassName" :span-method="arraySpanMethod"
          @selection-change="selectCurrentRow">
          <el-table-column type="selection" width="55" align="center" fixed="left"></el-table-column>
          <el-table-column prop="name" label="订单状态" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">待采购订单</span>
              <span v-if="scope.row.status == 2">待发货订单</span>
              <span v-if="scope.row.status == 3">待收货订单</span>
              <span v-if="scope.row.status == 4">已发货订单</span>
              <span v-if="scope.row.status == 5">已完成订单</span>
              <span v-if="scope.row.status == 9">已关闭订单</span>
            </template>
          </el-table-column>
          <el-table-column label="最近一次备注信息" width="300">
            <template slot-scope="scope">
              <h4>{{ scope.row.orderNote && scope.row.orderNote.note }}</h4>
              <div>
                <div style="display: inline-block;margin-right:5px;"
                  v-for="item in scope.row.orderNote && scope.row.orderNote.pics" :key="item">
                  <img :src="item" style="width:100px;height: 100px" />
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="付款状态" prop="" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.remotePaymentStatus == 0">待付款</span>
              <span v-if="scope.row.remotePaymentStatus == 1">部分付款</span>
              <span v-if="scope.row.remotePaymentStatus == 2">已付款</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="code" label="订单号" width="280">
            <template slot-scope="scope">
              <p>子订单号：{{ scope.row.orderNo }}</p>
              <p>外部订单号：{{ scope.row.outOrderNo }}</p>
              <el-tag size="mini" v-if="scope.row.platformType === 1 && scope.row.platformOrder" type="danger">
                京东订单：{{ scope.row.receivingName }} / 已下单：{{
                  scope.row.platformOrder
                }}
              </el-tag>
              <p>
                <el-tag size="mini" v-if="scope.row.isHaveAfterOrder" effect="dark" type="danger">有售后</el-tag>
              </p>
              <p>
                <el-tag size="mini" effect="dark" type="primary">分销订单</el-tag>
              </p>
            </template>
          </el-table-column>
          <el-table-column label="收货信息" width="280" v-if="![5,9].includes(searchData.Status)">
            <template slot-scope="scope" v-if="![5,9].includes(scope.row.status)">
              <div class="txt-l">
                <p>联系人：{{ scope.row.receivingName }}</p>
                <p>联系电话：{{ scope.row.receivingMobile }}</p>
                <p>
                  收货地址： {{ scope.row.receivingProviceName }}，
                  {{ scope.row.receivingCityName }}，
                  {{ scope.row.receivingDistrictName }}，
                  {{ scope.row.receivingStreetName }}，
                  {{ scope.row.receivingAddress }}
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品信息" min-width="250">
            <template slot-scope="scope">
              <div class="txt-l">
                <p>名称：{{ scope.row.orderItems && scope.row.orderItems[0] &&
                  scope.row.orderItems[0].productSkuName }}</p>
                <p>品牌：{{ scope.row.orderItems && scope.row.orderItems[0] &&
                  scope.row.orderItems[0].brandName }}</p>
                <p>品类：{{ scope.row.orderItems && scope.row.orderItems[0] &&
                  scope.row.orderItems[0].categoryName }}</p>
                <p>型号：{{ scope.row.orderItems && scope.row.orderItems[0] &&
                  scope.row.orderItems[0].productModel }}</p>
                <p>规格：{{ scope.row.orderItems && scope.row.orderItems[0] &&
                  scope.row.orderItems[0].productSpecExt }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="outOrderNo" label="订单金额" width="200">
            <template slot-scope="scope">
              <div class="txt-l">
                <p v-if="scope.row.orderItems && scope.row.orderItems[0] && scope.row.orderItems[0].unitBillPrice > 0">
                  单价：{{ scope.row.orderItems[0].unitBillPrice }}元</p>
                <!-- <p>单价：{{ scope.row.orderItems && scope.row.orderItems[0] &&
                                      scope.row.orderItems[0].unitPrice }}元</p> -->
                <p>数量：{{ scope.row.orderItems && scope.row.orderItems[0] &&
                  scope.row.orderItems[0].quantity }}</p>
                <p v-if="scope.row.orderItems && scope.row.orderItems[0]&&scope.row.orderItems[0].totalBillPrice > 0">合计：{{ scope.row.orderItems[0].totalBillPrice }}</p>
                <!-- <p>合计：{{ scope.row.orderItems && scope.row.orderItems[0] &&
                                      scope.row.orderItems[0].totalPrice  }}</p> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="物流信息" align="center" width="200">
            <template slot-scope="scope">
              <p class="line" v-for="(log, index) in scope.row.orderLogistics" :key="index"
                @click="checkDeliveryDetail(log)">{{ log.logisticsCompanyName }}{{ log.logisticsNo }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="creationTime" label="下单时间" width="200"></el-table-column>
          <el-table-column label="采购供应商" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 1">
                <el-autocomplete v-model="scope.row.supplierName" :fetch-suggestions="querySearchSupplierAsync"
                  placeholder="请选择供应商 可搜索" @select="((val) => { handleSelect1(val, scope.$index, scope.row) })">
                </el-autocomplete>
                <p class="txt-l">采购价：{{ scope.row.purchasePrice }}</p>
                <p>采购数量：
                  <el-input @input="(val) => checkVal(val, scope.row)" style="width:100px;"
                    v-model="scope.row.waitPurchaseQuantity"></el-input>
                </p>
              </div>
              <div v-else>
                <div class="txt-l" v-for="(item, index) in scope.row.orderPurchases" :key="index">
                  <p>{{ item.productSupplierName ? item.productSupplierName : '自有商品' }} {{ item.purchaseQuantity }}件</p>
                  <p>采购单号： {{ item.orderPurchaseNo }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" @click="showRemark(scope.row)" v-if="remarkShow" type="primary">备注</el-button>
              <el-button size="mini" type="primary" @click="orderDetail(scope.row)">订单详情</el-button>
              <el-button v-if="scope.row.status == 1" size="mini" type="primary"
                @click="handlePurchase(scope.row)">提交采购</el-button>
              <el-button v-if="scope.row.platformOrder === null &&
                scope.row.platformType === 1 &&
                scope.row.platformCode !== null &&
                scope.row.platformCode !== ''
                " size="mini" type="primary" @click="kplOrder(scope.row)">
                开普勒下单
              </el-button>
              <el-button v-if="scope.row.status >= 2" size="mini" type="primary"
                @click="deliveryBtn(scope.row)">{{ scope.row.status == 2 ? '发货' : '查看物流' }}</el-button>
              <el-button type="primary" size="mini" v-if="!scope.row.isRecepted && scope.row.status == 2"
                @click="receiveRoder(scope.row)">接单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="height: 35px">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="PageIndex"
          :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="searchData.MaxResultCount"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
      <div class="tip-box" v-if="afterSaleNum">
        <p @click="drawer = true">您的订单有售后！（{{ afterSaleNum }}）<i class="el-icon-arrow-right"></i></p>
      </div>
    </div>
    <el-drawer title="售后订单" :visible.sync="drawer" :modal="false" size="200">
      <div style="padding: 10px;">
        <p class="order-no" v-for="(val, indx) in afterSaleList" :key="indx" @click="handleAfterSale(val)">
          订单号：{{ val.erpOrderNo }}</p>
      </div>
    </el-drawer>
    <!-- 查询物流详情 -->
    <el-dialog title="查询物流详情" :visible.sync="loggisDetailDialog" :show-close="false" :close-on-click-modal="false"
      width="40%">
      <div v-if="loggisDetailList.length">
        <div v-for="(item, i) in loggisDetailList" :key="i" style="
            margin-bottom: 10px;
            padding-bottom: 10px;
            border-bottom: 1px dashed #eee;
          ">
          <p style="color: #999; font-size: 12px; margin-bottom: 5px">
            {{ item.time }}
          </p>
          <p style="color: #333; font-size: 14px">{{ item.description }}</p>
        </div>
      </div>
      <div v-if="loadLoggisDetailEnd && !loggisDetailList.length" style="
          text-align: center;
          color: #999;
          font-size: 14px;
          padding: 30px 0;
        ">
        暂无物流信息！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="loggisDetailDialog = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
          :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <div>
        <p>使用引导：</p>
        <p>1.下载模版后请准确校对系统订单的订单编号与采购编号，该编号用于识别具体订单信息</p>
        <p>2.模版导入可适用多物流，请根据模版表头进行准确填写物流单号与物流公司，发货数量。表头数字代表一组物流。物流备注非必填</p>
        <p>3.填写的信息需无格式化，可选中所填内容，右击清除格式</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 发货 -->
    <el-dialog title="发货" :visible.sync="deliveryDialog" :close-on-click-modal="false" append-to-body width="90%"
      @close="closeDialog">
      <div class="flex-wrap">
        <div class="flex-wrap cursor-p flex-1">
          <div class="mgr15" :class="{ supOn: supplierIndex == index }" @click="handleSup(sup, index)"
            v-for="(sup, index) in logisticsList" :key="index" v-show="sup.productSupplierName">{{ sup.productSupplierName
            }}</div>
        </div>
        <div style="text-align:right;">剩余发货数量：{{ toBeShippedNum }}</div>
      </div>
      <el-table border :data="logisticsList.length ? logisticsList[supplierIndex].items : []">
        <el-table-column label="发货数量" align="center" width="140">
          <template slot-scope="scope">
            <div class="flex-wrap">
              <el-input v-model.number="scope.row.shipmentQuantity"
                :disabled="getDisable(scope.row.shipmentQuantity, scope.row.logisticItems)"
                @input="(value) => changeInput(value, scope.row)"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="物流单号/物流公司" align="center">
          <template slot-scope="scope">
            <div class="" v-for="(item, index) in scope.row.logisticItems" :key="index">
              <div class="flex-wrap flex-center">
                <div class="flex-wrap flex-1">
                  <el-input class="flex-1" placeholder="输入物流单号" v-model="item.logisticsNo"
                    @change="getLogisticsByNumber(item)">
                    <el-button slot="append" style="background:#409EFF;color:#fff;"
                      @click="checkDeliveryDetail(item)">物流详情</el-button>
                  </el-input>
                  <el-autocomplete class="flex-1" v-model="item.logisticsCompanyName"
                    :fetch-suggestions="querySearchAsync" placeholder="选择物流公司"
                    @select="(value) => handleSelect(value, item)"></el-autocomplete>
                  <el-input class="flex-1" placeholder="本次货品数量" v-model.number="item.currentShipmentQuantity"
                    @input="(value) => changeInput2(value, scope.row, item)"></el-input>
                  <el-input class="flex-1" placeholder="输入备注信息" v-model="item.logisticsNote"></el-input>
                </div>
                <el-button v-if="scope.row.logisticItems.length > 1" type="text" style="font-size:29px;"
                  icon="el-icon-remove-outline" @click="deleteLogisticsInfo(scope.row.logisticItems, index)"></el-button>
              </div>
              <div class="txt-l">
                <el-button type="text" @click="annexLogistics(scope.$index, index, item.supLogisticsJson)">附件物流</el-button>
              </div>
            </div>
            <el-button v-if="getNum(scope.row.shipmentQuantity, scope.row.logisticItems)" type="text"
              style="font-size:29px;" icon="el-icon-circle-plus-outline" @click="addLogisticsInfo(scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" width="140">
          <template slot-scope="scope">
            <el-button style="margin-bottom:10px;" type="primary" size="mini"
              :disabled="toBeShippedNum == 0 && orderItem.status != 2" @click="saveLogistics(scope.row)">保存并同步</el-button>
            <el-button type="danger" size="mini" :disabled="toBeShippedNum == 0 && orderItem.status != 2"
              @click="deleteLogistics(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" style="text-align: left;" v-if="toBeShippedNum > 0">
        <el-button type="primary" icon="el-icon-plus" @click="addLogistics">新增物流</el-button>
      </div>
    </el-dialog>
    <!-- 附件物流 -->
    <el-dialog title="附件物流" :visible.sync="dialogAnnexLogistics" :close-on-click-modal="false" width="80%">
      <el-table border :data="annexList">
        <el-table-column label="物流单号/物流公司" align="center">
          <template slot-scope="scope">
            <div class="flex-wrap">
              <el-input class="flex-1" placeholder="输入物流单号" v-model="scope.row.logisticsNo"></el-input>
              <el-autocomplete class="flex-1" v-model="scope.row.logisticsCompanyName"
                :fetch-suggestions="querySearchAsync" placeholder="选择物流公司"
                @select="(value) => handleSelect(value, scope.row)"></el-autocomplete>
              <el-input class="flex-1" placeholder="本次货品数量" v-model.number="scope.row.currentShipmentQuantity"></el-input>
              <el-input class="flex-1" placeholder="输入备注信息" v-model="scope.row.logisticsNote"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="140" align="center">
          <template slot="header" slot-scope="scope">
            <el-button type="primary" icon="el-icon-plus" @click="addAnnex()">新增物流</el-button>
          </template>
          <template slot-scope="scope">
            <el-button type="text" @click="deleteAnnex(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="submitAnnex">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="detailDialog" title="备注" width="70%" :visible.sync="detailDialog" :close-on-click-modal="false">
      <el-form class="demo-form-inline">
        <el-form-item label="备注信息：">
          <el-input style="width: 400px;" type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" placeholder="请输入内容"
            v-model="textarea2">
          </el-input>
        </el-form-item>
        <el-form-item label="图片：">
          <div style="display: inline-block" class="img_box1" v-for="(item, index) in UploadFileUrl">
            <p class="del_box" @click.stop="handleDelPic(index)">
              <img src="../../assets/del-icon.png" alt />
            </p>
            <img :src="item" alt @click.stop="handleBigPic(item)" />
          </div>
          <el-upload style="display: inline-block" class="avatar-uploader" action :show-file-list="false"
            :auto-upload="false" :on-change="handleBusinessPic">
            <i class="el-icon-plus avatar-uploader-icon plus-sign"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <h3>备注记录</h3>
      <div v-loading="markLoading">
        <el-card style="margin-bottom:20px;" v-for="(item, index) in remarkList">
          <div style="margin:10px;">
            <el-row>
              <el-col :span="18">
                {{ item.note }} <br />
                <h4>{{ item.creationUser }} &nbsp;&nbsp;{{ item.creationTime }}</h4>
              </el-col>
              <el-col :span="6">
                <img :src="item1" style="width:80px;height:80px;margin-right:5px;cursor: pointer;"
                  v-for="(item1, index1) in item.pics" />
              </el-col>
            </el-row>

          </div>
        </el-card>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button v-prevent-click type="primary" @click="submitRemark">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  OrderGetAllMany,
  SupplierGetAll,
  ExportMany,
  GetOrderLogistics,
  BatchCreate1,
  JdCtpOrder,
  ImportMany,
  OrderWarehouseGetAll,
  LogisticsCompanyServiceGetAll,
  CreateAndPushMany,
  GetLogisticsMany,
  DeleteAndPushMany,
  GetCountMany,
  DeleteAndPushItem,
  AfterSaleListForERP,
  GetLogisticsByNumber, getQiniuToken, OrderCreateOrderNote, OrderGetOrderNoteList,
  Recepted
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import toolbar from "../../components/Toolbar";
export default {
  components: { toolbar },
  data() {
    return {
      markLoading: false,
      remarkList: [],
      noteId: null,
      textarea2: '',
      qiniuToken: '',
      UploadFileUrl: [],
      detailDialog: false,
      remarkShow: false,
      drawer: false,
      tabList: [
        {
          label: "全部",
          id: null,
          num: 0
        },
        {
          label: "待采购",
          id: 1,
          num: 0
        },
        {
          label: "待发货",
          id: 2,
          num: 0
        },
        {
          label: "待收货",
          id: 3,
          num: 0
        },
        {
          label: "已收货",
          id: 4,
        },
        {
          label: "已完成",
          id: 5,
          num: 0
        },
        {
          label: "已关闭",
          id: 9,
          num: 0
        },
      ],
      searchData: {
        Status: null,
        OrderNo: null,
        ProductSkuName: null,
        ReceivingName: null,
        ProductModel: null,
        ReceivingMobile: null,
        SupplierId: null,
        OutOrderNo: null,
        // RemotePaymentStatus: null,
        CreationStartTime: null,
        CreationEndTime: null,
        SkipCount: 0,
        MaxResultCount: 10,
      },
      datePicker: [],
      PageIndex: 1, //页码
      supplier: [],
      status: [
        { value: null, label: "全部" },
        { value: 1, label: "待采购订单", class: "table-row-1" },
        { value: 2, label: "待发货订单", class: "table-row-2" },
        { value: 3, label: "待收货订单", class: "table-row-3" },
        { value: 4, label: "已发货订单", class: "table-row-4" },
      ],
      loading: false,
      tableData: [],
      total: 0,
      buttonList_toolBar: [],

      loggisDetailDialog: false,
      loggisDetailList: [],
      loadLoggisDetailEnd: false,
      logisDetailShow: false,

      logisticsVisible: false,
      uploading: false,
      fileLog: null,

      isKplOrder: false,
      deliveryDialog: false,
      form: {
        // productSupplierName: '',
        logisticsNo: "",
        orderId: "",
        orderPurchaseId: "",
        logisticsCompanyId: "",
        logisticsCompanyName: "",
        logisticsCompanyCode: "",
        currentShipmentQuantity: null,
        // currentShipmentQuantity: null,
        // remainQuantity: null,
        // productSupplierId: null,
        purchaseQuantity: "",
        // purchaseTotal: '',
        // purchasePrice: '',
        // orderNo: '',
        warehouseId: null,
        warehouseName: "",
      },
      logisticsList: [
        {
          purchaseQuantity: 0,
          items: [{
            orderId: null,
            orderPurchaseId: null,
            shipmentQuantity: null,
            logisticItems: [{
              logisticsCompanyId: null,
              logisticsCompanyName: null,
              logisticsCompanyCode: null,
              currentShipmentQuantity: null,
              logisticsNo: null,
              logisticsNote: null,
              isPush: false,
              supLogisticsJson: null
            }]
          }]
        }
      ],
      logisCompanyData: [],
      supplierIndex: 0,
      orderItem: {},
      dialogAnnexLogistics: false,
      annexList: [],
      logisticsIndex: 0,
      logisticsChildIndex: 0,
      orderNum: {},
      selectRow: [],
      afterSaleNum: 0,
      afterSaleList: []
    };
  },
  created() {
    this.getAfterSaleListForERP()
    this.getCountMany()
    this.queryData();
    this.querySupplier();
    this.getAllCompany()
    this.getQiniuToken()
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    console.log('buttonList', buttonList)
    if (buttonList && buttonList.length > 0) {
      buttonList.forEach((item) => {
        if (item.buttonFunc === "orderRemark") {
          this.remarkShow = true;
        }
      });
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
    }
  },
  computed: {
    toBeShippedNum() {
      if (this.logisticsList.length) {
        let num = this.logisticsList[this.supplierIndex].items.reduce((pre, cur) => {
          return pre + cur.shipmentQuantity
        }, 0)
        let num2 = this.logisticsList[this.supplierIndex].purchaseQuantity
        if (num2 - num < 0) {
          // this.$message.error('超出发货数量，请确认发货数量')
          return 0
        } else {
          return num2 - num
        }
      } else {
        return 0
      }
    }
  },
  methods: {
    receiveRoder(row) {
      Recepted({ id: row.id }).then(res => {
        if (res.data.success) {
          this.queryData()
          // this.$message.success()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    async submitRemark() {
      if (!this.textarea2) {
        return this.$message.error('请填写备注信息')
      }
      let params = {};
      params.orderId = this.noteId;
      params.note = this.textarea2;
      params.images = this.UploadFileUrl.join(',') || '';
      let res = await OrderCreateOrderNote(params);
      if (res.data.success) {
        this.textarea2 = '';
        this.UploadFileUrl = [];
        this.detailDialog = false;
        this.$message.success('添加备注成功')
        await this.queryData();
      } else {
        this.$message.error(res.data.error.message)
      }
      console.log('res beizhu add', res);
    },
    //获取七牛token
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
        .catch(() => {
        });
    },
    handleBusinessPic(file) { // 上传图片
      console.log(123)
      let that = this;
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.png`,
        token: this.qiniuToken
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then(res => {
          this.UploadFileUrl.push(res);
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    handleDelPic(index) { // 删除图片
      this.UploadFileUrl.splice(index, 1);
    },
    handleBigPic(src) { // 放大图片
      // this.dialogVisible = true;
      // this.dialogImageUrl = src;
    },
    async showRemark(row) {
      this.markLoading = true;
      this.noteId = row.id;
      let res = await OrderGetOrderNoteList({ orderId: row.id })
      console.log('备注列表', res);
      if (res.data.success) {
        this.markLoading = false;
        if (res.data.result) {
          res.data.result.forEach((item, index) => {
            if (item.images) {
              item.pics = item.images.split(',')
            }
          })
        }
        this.remarkList = res.data.result
      } else {
        this.markLoading = false;
        this.$message.error(res.data.error.message);
      }
      this.detailDialog = true;

    },
    // changeLogistics(item) {
    //   console.log(item,'ddd')
    //   this.getLogisticsByNumber(item)
    // },
    getLogisticsByNumber(item) {
      let data = {
        code: item.logisticsNo
      }
      GetLogisticsByNumber(data).then(res => {
        if (res.data.success) {
          let code = res.data.result[0].comCode
          let obj = this.logisCompanyData.filter(val => {
            return val.code == code
          })
          console.log(obj, 'obj')
          item.logisticsCompanyCode = obj[0].code
          item.logisticsCompanyId = obj[0].id
          item.logisticsCompanyName = obj[0].value
        }
      })
    },
    handleAfterSale(row) {
      this.searchData.OrderNo = row.erpOrderNo
      this.PageIndex = 1
      this.queryData()
    },
    getAfterSaleListForERP() {
      let data = {
        PageIndex: 1,
        PageSize: 100
        // SkipCount: 0,
        // MaxResultCount: 100,
      }
      AfterSaleListForERP(data).then(res => {
        if (res.data.success) {
          this.afterSaleList = res.data.result.data.data || []
          this.afterSaleNum = res.data.result.data.dataCount || 0
        }
      })
    },
    selectCurrentRow(row) {
      this.selectRow = row
    },
    getDisable(val, list) {
      let num = list.reduce((pre, cur) => {
        return pre + cur.currentShipmentQuantity
      }, 0)
      if (val) {
        if (val - num <= 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getNum(val, list) {
      let num = list.reduce((pre, cur) => {
        return pre + cur.currentShipmentQuantity
      }, 0)
      if (val - num <= 0) {
        return false
      } else {
        return true
      }
    },
    async querySearchSupplierAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    async getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.supplierName = key;
      }
      return new Promise((resolve, reject) => {
        SupplierGetAll(obj).then((res) => {
          console.log('供应商列表', res);
          if (res.data.success) {
            // this.supplier = res.data.result.items;
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.proSupplierName,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    handleSelect1(item, index, row) {
      this.$set(this.tableData[index], 'sourceId', item.id);
      this.$set(this.tableData[index], 'supplierName', item.value);
      console.log('this.tableData[index]', this.tableData[index]);
    },
    getCountMany() {
      GetCountMany().then(res => {
        if (res.data.success) {
          let { all, paySuccess, toBeShipped, shipped, received, complated, close } = res.data.result
          this.tabList[0].num = all
          this.tabList[1].num = paySuccess
          this.tabList[2].num = toBeShipped
          this.tabList[3].num = shipped
          this.tabList[4].num = received
          this.tabList[5].num = complated
          this.tabList[6].num = close
        }
      })
    },
    getLogisticsMany() {
      this.supplierIndex = 0
      GetLogisticsMany({ orderId: this.orderItem.id }).then(res => {
        // console.log(res,'res.data.result')
        if (res.data.success) {
          this.logisticsList = res.data.result
        }
      })
    },
    async querySearchAsync(queryString, cb) {
      console.log(queryString, cb, 'ffffff')
      if (queryString) {
        let res = await this.getAllCompany(queryString);
        cb(res);
      } else {
        let res = await this.getAllCompany();
        cb(res);
      }
    },
    getAllCompany(key, type) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      // if (type) {
      //   obj.ExpressHundredCode = key
      // }
      if (key) {
        obj.LogisticsCompanyName = key;
        // ExpressHundredCode
      }
      return new Promise((resolve, reject) => {
        LogisticsCompanyServiceGetAll(obj).then((res) => {
          if (res.data.success) {
            this.logisCompanyData = res.data.result.items
              .map((item) => {
                return {
                  value: item.fullName,
                  id: item.id,
                  code: item.expressHundredCode
                };
              });
            resolve(this.logisCompanyData);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    handleSelect(value, item) {
      item.logisticsCompanyId = value.id
      item.logisticsCompanyCode = value.code
    },
    handleSup(row, index) {
      this.supplierIndex = index
      this.logisticsList.forEach(item => {
        item.orderPurchaseId = row.productSupplierId
      })
    },
    changeInput2(value, row, item) {
      let num = row.logisticItems.reduce((pre, cur) => {
        return pre + cur.currentShipmentQuantity
      }, 0)
      if (row.shipmentQuantity - num < 0) {
        this.$message.error('超出发货数量，请确认发货数量')
        item.currentShipmentQuantity = null
      }
    },
    changeInput(value, row) {
      let num = this.logisticsList[this.supplierIndex].items.reduce((pre, cur) => {
        return pre + cur.shipmentQuantity
      }, 0)
      let num2 = this.logisticsList[this.supplierIndex].purchaseQuantity
      if (num2 - num < 0) {
        this.$message.error('超出发货数量，请确认发货数量')
        row.shipmentQuantity = null
      }

      let obj = {
        logisticsCompanyId: null,
        logisticsCompanyName: null,
        logisticsCompanyCode: null,
        currentShipmentQuantity: null,
        logisticsNo: null,
        logisticsNote: null,
        isPush: false,
        supLogisticsJson: null
      }
    },
    deleteLogisticsInfo(list, index) {
      if (list[index].orderLogisticId) {
        this.$confirm("确认删除吗?", "提示", {
          type: "warning",
          closeOnClickModal: false,
        }).then(() => {
          DeleteAndPushItem({ orderLogisticId: list[index].orderLogisticId }).then(res => {
            if (res.data.success) {
              this.$message.success('删除成功！')
              list.splice(index, 1)
            } else {
              this.$message.error(res.data.error.message)
            }
          })
        })
      } else {
        list.splice(index, 1)
      }
    },
    deleteLogistics(row, index) {
      if (row.orderWarehouseId) {
        this.$confirm("确认删除吗?", "提示", {
          type: "warning",
          closeOnClickModal: false,
        }).then(() => {
          DeleteAndPushMany({ orderWarehouseId: row.orderWarehouseId }).then(res => {
            if (res.data.success) {
              this.$message.success('删除成功！')
              this.logisticsList[this.supplierIndex].items.splice(index, 1)
            } else {
              this.$message.error(res.data.error.message)
            }
          })
        })
      } else {
        this.logisticsList[this.supplierIndex].items.splice(index, 1)
      }
    },
    addLogistics() {
      let { orderPurchasesId, orderId } = this.logisticsList[this.supplierIndex]
      this.logisticsList[this.supplierIndex].items.push({
        orderId: orderId,
        orderPurchaseId: orderPurchasesId,
        orderWarehouseId: null,
        shipmentQuantity: null,
        // warehouseId: 0,
        // warehouseName: null,
        logisticItems: [{
          logisticsCompanyId: null,
          logisticsCompanyName: null,
          logisticsCompanyCode: null,
          currentShipmentQuantity: null,
          logisticsNo: null,
          logisticsNote: null,
          isPush: false,
          supLogisticsJson: null
        }]
      })
    },
    addLogisticsInfo(row) {
      let num = row.logisticItems.reduce((pre, cur) => {
        return pre + cur.currentShipmentQuantity
      }, 0)
      let obj = {}
      if (row.logisticItems.length) {
        obj = row.logisticItems[row.logisticItems.length - 1]
      }
      if (row.shipmentQuantity > num) {
        row.logisticItems.push({
          logisticsCompanyId: obj.logisticsCompanyId ? obj.logisticsCompanyId : null,
          logisticsCompanyName: obj.logisticsCompanyName ? obj.logisticsCompanyName : null,
          logisticsCompanyCode: obj.logisticsCompanyCode ? obj.logisticsCompanyCode : null,
          currentShipmentQuantity: null,
          logisticsNo: null,
          logisticsNote: null,
          isPush: false,
          supLogisticsJson: null
        })
      }
    },
    annexLogistics(index, logIndex, strList) {
      this.annexList = []
      this.logisticsIndex = index
      this.logisticsChildIndex = logIndex
      this.annexList = strList ? JSON.parse(strList) : []
      this.dialogAnnexLogistics = true
    },
    addAnnex() {
      this.annexList.push({
        logisticsCompanyId: null,
        logisticsCompanyName: null,
        logisticsCompanyCode: null,
        currentShipmentQuantity: null,
        logisticsNo: null,
        logisticsNote: null,
      })
    },
    deleteAnnex(index) {
      this.annexList.splice(index, 1)
    },
    submitAnnex() {
      this.logisticsList[this.supplierIndex].items[this.logisticsIndex].logisticItems[this.logisticsChildIndex].supLogisticsJson = JSON.stringify(this.annexList)
      this.dialogAnnexLogistics = false
    },
    closeDialog() {
      this.dialogAnnexLogistics = false
      // if (this.orderItem.status==2) {
      //   this.PageIndex = 1
      //   this.queryData()
      //   this.getCountMany()
      // }
    },
    saveLogistics(row) {
      console.log(row, 'dddd')
      if (!row.shipmentQuantity) {
        return this.$message.error('请输入发货数量！')
      }
      let flag = row.logisticItems.every(item => {
        return item.logisticsNo && item.logisticsCompanyId && item.currentShipmentQuantity
      })
      if (!flag) {
        return this.$message.error('请检查物流单号、物流公司、本次发货数量是否都已填写！')
      }
      const loading = this.$loading({
        lock: true,
        text: '请稍等！',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      CreateAndPushMany(row).then(res => {
        if (res.data.success) {
          loading.close();
          this.getLogisticsMany()
          this.$message.success(res.data.result.message)
        } else {
          loading.close();
          this.$message.error(res.data.error.message)
        }
      })
    },
    handOrderStatus(item) {
      this.PageIndex = 1;
      this.searchData.Status = item.id;
      this.queryData();
    },
    orderDetail(row) {
      // this.$router.push(`/OrderManagement/Purchasing/OrderDetail?id=${row.id}`);
    },
    async batchPurchase() {
      if (!this.selectRow[0]) {
        return this.$message.error('请选择要采购的订单')
      }
      let list = []
      this.selectRow.forEach(item => {
        if (item.status == 1) {
          list.push({
            orderId: item.id,
            productSupplierId: item.sourceId,
            purchaseQuantity: item.waitPurchaseQuantity,
            purchaseTotal: item.purchaseTotal,
            purchasePrice: item.purchasePrice,
            orderNo: item.orderNo,
            productSupplierName: item.supplierName,
          })
        }
      })
      if (!list[0]) {
        return this.$message.error('请选择待采购的订单进行提交！')
      }
      let res = await BatchCreate1(list);
      if (res.data.success) {
        this.$message.success("采购成功");
        this.searchData.PageIndex = 1;
        await this.queryData();
        await this.getCountMany()
      } else {
        this.$message.error(res.data.error.message || "采购失败, 请重试");
      }
    },
    handlePurchase(row) {
      this.$confirm("确认提交采购吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      })
        .then(async () => {
          let params = {};
          params.orderId = row.id;
          params.productSupplierId = row.sourceId;
          params.purchaseQuantity = row.waitPurchaseQuantity;
          params.purchaseTotal = row.purchaseTotal;
          params.purchasePrice = row.purchasePrice;
          params.orderNo = row.orderNo;
          params.productSupplierName = row.supplierName;
          // console.log('提交采购params', params); return;
          let res = await BatchCreate1([params]);
          console.log("提交采购", res);
          if (res.data.success) {
            this.$message.success("采购成功");
            this.searchData.PageIndex = 1;
            await this.queryData();
            await this.getCountMany()
          } else {
            this.$message.error(res.data.error.message || "采购失败, 请重试");
          }
        })
        .catch(() => { });
    },
    async kplOrder(row) {
      this.$confirm("是否确认下单", "提示", {
        closeOnClickModal: false,
      })
        .then(async () => {
          console.log("开普勒下单", row);
          /*
           * platformOrder 订单号
           * platformType  京东开普勒  1
           * 已下单
           * */
          console.log("row.platformOrder", row.platformOrder);
          console.log("row.platformType", row.platformType);
          // return
          if (row.platformOrder && row.platformType === 1) {
            return this.$message.error("此商品已经下单,无需重复下单");
          }

          /*
           * id 订单id
           * 未下单
           * */

          if (!row.platformOrder && row.platformType === 1 && row.id) {
            // console.log('-----');return;
            let res = await JdCtpOrder({ id: row.id });
            // console.log('开普勒下单', res);

            // 下单成功
            if (res.data.result.success && res.data.result.code !== -1) {
              this.$message.success("下单成功");
              await this.getTableData();
              // } else if (!res.data.success && res.data.code === -1) {
            } else if (
              !res.data.result.success &&
              res.data.result.code === -1
            ) {
              this.$confirm(
                "下单失败：商品成本价与京东价格不一致,是否更新成本价格并重新下单?",
                "提示",
                {
                  closeOnClickModal: false,
                }
              )
                .then(async () => {
                  let res = await JdCtpOrder({
                    id: row.id,
                    isSkipCostPirce: true,
                  });
                  if (res.data.result.success) {
                    this.$message.success(
                      res.data.result.message || "下单成功"
                    );
                    await this.getTableData();
                  } else {
                    this.$message.error(
                      res.data.result.message || "下单失败, 请重试"
                    );
                  }
                })
                .catch(() => { });
            } else {
              this.$message.error(
                res.data.result.message || "下单失败, 请重试"
              );
            }
            /*
             * -1 价格低于京东价格 需要重新下单
             * isSkipCostPirce true
             * */
            // if () {
            //
            // }
          }
        })
        .catch(() => { });
    },
    importBtn() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    upDataInfo() {
      window.open(
        "https://homeimage.ksaxshop.com/ERP%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
        // "https://homeimage.ksaxshop.com/erp/order/%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    handleExpSubmit() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("file", this.fileLog);
      ImportMany(formData).then((res) => {
        if (!res.data.result) {
          this.$message.success("上传成功！");
          this.uploading = false;
          this.logisticsVisible = false;
          this.fileLog = null;
          this.getTableList();
        } else {
          this.$message.error(res.data.result);
          this.uploading = false;
        }
      });
    },
    async deliveryBtn(row) {
      this.deliveryDialog = true;
      this.orderItem = row
      this.getLogisticsMany()
    },
    checkDeliveryDetail(data) {
      console.log(data, 'data')
      // if (!this.logisDetailShow) return;
      this.loggisDetailList = [];
      this.loadLoggisDetailEnd = false;
      this.loggisDetailDialog = true;
      GetOrderLogistics({
        LogisticsCompanyCode: data.logisticsCompanyCode,
        LogisticsCode: data.logisticsNo,
      }).then((res) => {
        if (res.data.success) {
          this.loggisDetailList = res.data.result.data;
        }
        this.loadLoggisDetailEnd = true;
      });
    },
    queryData() {
      this.loading = true;
      this.searchData.SkipCount = (this.PageIndex - 1) * this.searchData.MaxResultCount;
      OrderGetAllMany(this.searchData).then((res) => {
        if (res.data.success) {
          if (res.data.result && res.data.result.items) {
            res.data.result && res.data.result.items.forEach((item, index) => {
              if (item.orderNote) {
                item.orderNote.pics = item.orderNote.images.split(',')
              }
            })
          }
          console.log('res.data.result.items', res.data.result.items);
          this.tableData = res.data.result.items;
          this.total = res.data.result.totalCount;
          let index = this.tabList.findIndex(item => {
            return item.id == this.searchData.Status
          })
          this.tabList[index].num = res.data.result.totalCount
        }
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
    },
    querySupplier(value) {
      SupplierGetAll({
        SkipCount: 0,
        MaxResultCount: 100,
        supplierName: value,
      }).then((res) => {
        if (res.data.success) {
          this.supplier = res.data.result.items;
        }
      });
    },
    handleSizeChange(val) {
      this.searchData.MaxResultCount = val;
      this.queryData();
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.queryData();
    },
    getData() {
      this.PageIndex = 1;
      this.queryData();
    },
    resetForm() {
      this.datePicker = [];
      this.searchData.CreationStartTime = "";
      this.searchData.CreationEndTime = "";
      this.PageIndex = 1;
      this.searchData.MaxResultCount = 10;
      this.$refs["searchData"].resetFields();
      this.queryData();
    },
    handlePicker(val) {
      if (!val) {
        this.searchData.CreationStartTime = "";
        this.searchData.CreationEndTime = "";
      } else {
        this.searchData.CreationStartTime = val[0];
        this.searchData.CreationEndTime = val[1];
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.status === 1) {
        return "table-row-1";
      } else if (row.status === 2) {
        return "table-row-2";
      } else if (row.status === 3) {
        return "table-row-3";
      } else if (row.status === 4) {
        return "table-row-4";
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex === 8) {
      //     return [1, 6]
      // }
      // if (rowIndex % 2 === 0) {
      //     if (columnIndex === 0) {
      //         return [1, 2];
      //     } else if (columnIndex === 1) {
      //         return [0, 0];
      //     }
      // }
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    handleExport() {
      this.searchData.SkipCount = (this.PageIndex - 1) * this.searchData.MaxResultCount;
      ExportMany(this.searchData).then((res) => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=UTF-8",
        });
        let objectUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.download = "订单列表数据.xlsx";
        a.href = objectUrl;
        a.click();
        a.remove();
      });
    },
  },
};
</script>
<style scoped>
.box-card {
  margin: 0 20px;
}

.h100 {
  height: 100%;
}

.txt-l {
  text-align: left;
}

.overflow-y {
  overflow-y: auto;
}

.cursor-p {
  cursor: pointer;
}

.supOn {
  position: relative;
  font-weight: 700;
}

.supOn::after {
  content: '';
  display: block;
  background: #000;
  width: 30px;
  height: 2px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.mgr15 {
  margin-right: 15px;
}

.flex-wrap {
  display: flex;
}

.flex-1 {
  flex: 1;
}

.flex-center {
  align-items: center;
}

.flex-sa {
  justify-content: space-between;
}

.flex-col {
  flex-direction: column;
}

.tab-box {
  font-size: 18px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #333333;
  padding-top: 10px;
}

.tab-item {
  margin: 0 16px;
  cursor: pointer;
  position: relative;
}

.tag {
  position: absolute;
  top: 0;
  right: 10px;
  transform: translateY(-50%) translateX(100%);
  background-color: #F56C6C;
  border-radius: 10px;
  color: #FFF;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #FFF;
}

.activeTab {
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3b6ffa;
  position: relative;
}

.activeTab:after {
  content: "";
  width: 25px;
  height: 2px;
  background: #3b6ffa;
  border-radius: 2px;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.bd-b {
  margin: 10px 0;
  width: 100%;
  height: 1px;
  background: #e3e9ef;
}

.form-bg {
  background: #f7f9fc;
  border-radius: 4px;
}

.table-row-1 {
  background: oldlace;
}

.table-row-2 {
  background: #f0f9eb;
}

.table-row-3 {
  background: #eaeefb;
}

.table-row-4 {
  background: #f8e2e2;
}

.el-table>>>.table-row-1 {
  background: oldlace;
}

.el-table>>>.table-row-2 {
  background: #f0f9eb;
}

.el-table>>>.table-row-3 {
  background: #eaeefb;
}

.el-table>>>.table-row-4 {
  background: #f8e2e2;
}

.line {
  cursor: pointer;
  text-decoration: underline;
}

.ul {
  display: flex;
}

.ul li {
  display: flex;
  align-items: center;
  margin-right: 10px;
  font-size: 14px;
  color: #606266;
}

.ul li div {
  width: 14px;
  height: 14px;
}

.ul li p {
  margin-left: 5px;
}

.el-table {
  margin-top: 10px;
}

.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tip-box {
  cursor: pointer;
  padding: 10px;
  border-radius: 6px;
  position: fixed;
  z-index: 99;
  right: 0;
  bottom: 20px;
  background: rgba(255, 192, 203, 0.5);
}

.order-no {
  cursor: pointer;
  color: #409eff;
}

.scroll-y {
  height: 200px;
  overflow-y: scroll;
}

.img_box1 {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  margin-right: 10px;
}

.img_box1 img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.del_box {
  position: absolute;
  top: -15px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
</style>
